<!--
 * @Description: 
 * @Author: git config user.name
 * @Date: 2024-07-10 09:14:35
 * @LastEditors: git config user.name
 * @LastEditTime: 2024-07-10 09:14:54
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\platform-services\home.vue
-->
<!--
    描述：入口页面
    Created by zl
-->
<template>
	<transition name="fade"
				mode="out-in">
		<!-- 用做缓存页面 -->
		<keep-alive :include="cachedViews">
			<router-view :key="key" />
		</keep-alive>
	</transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'platform-services-home',
	data() {
		return {}
	},
	methods: {},
	computed: {
		...mapState('tags', {
			cachedViews: state => state.cacheTags
		}),
		key() {
			// console.log(this.$route.name)
			return this.$route.name
		}
	}
}
</script>

<style scoped lang="less">
</style>

